import { c as _c } from "react/compiler-runtime";
import { cn } from '@heroui/react';
import { SocialIcon } from 'react-social-icons';
interface Props {
  socials: {
    website?: string;
    all?: string[];
  };
  className?: string;
}
export function SocialsButtons(t0) {
  const $ = _c(10);
  const {
    socials,
    className
  } = t0;
  if (!socials.website && !socials.all?.length) {
    return null;
  }
  const t1 = className ? className : "";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex flex-row justify-center space-x-2", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== socials.website) {
    t3 = socials.website && <SocialIcon url={socials.website} key={socials.website} style={{
      height: 25,
      width: 25
    }} />;
    $[2] = socials.website;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== socials.all) {
    t4 = socials.all?.map(_temp);
    $[4] = socials.all;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp(social) {
  return <SocialIcon url={social} key={social} style={{
    height: 25,
    width: 25
  }} />;
}